import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/core/navbar";
import ScrollToTop from "./components/core/ScrollToTop";

import Home from "./components/pages/main/index";
import Services from "./components/pages/services/index";
import Team from "./components/pages/team/index";
import Locations from "./components/pages/locations/index";
import Faq from "./components/pages/faq/index";
import BookNow from "./components/pages/book-now/index";

import Footer from "./components/core/footer";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/team" element={<Team />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/book-now" element={<BookNow />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
